import axios from './axios'
import qs from 'qs'
let profix="/63333/api"
// 判断用户是否登录,获取用户信息
export const whoami = (args) => axios.get(`${profix}/user/wechat/whoami`,{
  params: args
})

//获取手机验证码
export const getCode = (args) => axios.get(`${profix}/user/wechat/getCode`,{
  params: args
})
//绑定手机号
export const bindMobile = (args) => axios.get(`${profix}/user/wechat/bindMobile`,{
  params: args
})

let configForm = {
  headers: {
    'Content-Type': 'multipart/form-data;'
  }
}
let configJson = {
  headers: {
    'Content-Type':'application/json;'
  }
}
//基金会筹款项目
export const foundationList = (args) => axios.get(`${profix}/applets/foundation/get/list`,{
  params: args
})
export const foundationDetail = (id,args) => axios.get(`${profix}/applets/foundation/get/detail/${id}`,{
  params: args
})
//查询是否需要弹窗
export const isPayed = (id) => axios.get(`${profix}/applets/foundation/get/isPayed/${id}`)
export const isPay = (id) => axios.get(`${profix}/applets/foundation/get/isPay/${id}`)
export const isPayV2 = (id) => axios.get(`${profix}/applets/foundation/get/isPay/V2/${id}`)
export const foundationPay = (args,params) => axios.post(`${profix}/applets/foundation/post/pay`,args, {
  headers:{
    't':params
  }
})
export const updateClickRepeat = (id) => axios.put(`${profix}/applets/foundation/put/updateClickRepeat/${id}`)
//记录点击
export const clickRecord = (args) => axios.post(`${profix}/applets/foundation/post/click`,args,configJson)
export const tecentWelfareList = (args) => axios.get(`${profix}/applets/gongyi/get/gongyiList`,{
  params: args
})
export const getWelfareUrl = (args) => axios.get(`${profix}/applets/gongyi/get/gongyiUrl`,{
  params: args
})
//支付
export const createOrder = (args) => axios.post(`${profix}/applets/foundation/post/pay`,args, configJson)
//支付宝支付
export const aliPayOrder = (args) => axios.post(`${profix}/applets/foundation/post/aliPay/submitOrder`,args, configJson)
//月捐支付
export const trustH5 = (args) => axios.post(`${profix}/applets/foundation/post/trustH5`,args)
//微信公众号月捐签约
export const enTrustWeb = (args) => axios.post(`${profix}/applets/foundation/post/enTrustWeb`,args)
export const aliPay = (id) => axios.post(`${profix}/applets/foundation/post/aliPay/${id}`)
//巨量引擎数据统计
export const postData = (args) => axios.post(`${profix}/applets/foundation/post/postData`,args,configJson)
//vivo投放数据回传
export const postVData = (args) => axios.post(`${profix}/applets/foundation/post/postVData`,args,configJson)
//快手h5付费数据回传
export const postKSData = (args) => axios.post(`${profix}/applets/foundation/post/postKData`,args,configJson)
//爱奇艺投放数据回传
export const postIQiYiData = (args) => axios.post(`${profix}/applets/foundation/post/postIQiYiData`,args,configJson)

//保存用户资料
export const userinfoSave = (args) => axios.post(`${profix}/applets/foundation/save/userinfo`,args,configJson)

//生成证书编号
export const createCertificate = (args) => axios.get(`${profix}/applets/foundation/createCertificate`,{
  params: args
})
//月捐是否扣款成功
export const isPayMonthly = (id) => axios.get(`${profix}/applets/foundation/monthly/isPay?monthlyId=${id}`)
//跳转腾讯公益页面h5支付
export const payGY = (args) => axios.post(`${profix}/applets/foundation/gy/pay`,args,configJson)
//获取验证码
export const mobileyzm = (args) => axios.get(`${profix}/activity/getYzm?type=1&mobile=${args}`)
//活动页提交
export const infosubmit = (args) => axios.post(`${profix}/activity/submit`,args,configJson)
//获取滚动用户列表
export const listRecord = (args) => axios.get(`${profix}/applets/foundation/get/listRecord`,{
  params: args
})
//记录滑到底部
export const slideBottom = (args) => axios.get(`${profix}/fb/slideBottom`,{
  params: args
})
//保存证书申请信息
export const certificateSave = (args) => axios.post(`${profix}/foundation/apply/certificate/save`,args,configJson)
export const certPay = (args) => axios.post(`${profix}/applets/gy/order/cert/pay/${args}`)

export const invoiceSave = (args) => axios.post(`${profix}/foundation/apply/invoice/save`,args,configJson)
export const updateImg = (args) => axios.post(`https://files.liuliangbang.vip/pic/ups?ossAccount=Sx`,args,configForm)

// 志愿者 获奖证书申请
export const certSave = (args) => axios.post(`${profix}/applets/cert/save`, args, configJson)
//获取社群爱心回礼内容的url
export const giftGet = (id,args) => axios.get(`${profix}/applets/foundation/url/gift/${id}`,{
  params: args
})
//捐赠人满足回礼条件时填写的地址表单
export const submitGift = (args) => axios.post(`${profix}/applets/foundation/addr/gift/submit`, args, configJson)



// WEBPACK FOOTER //
// ./src/api/index.js